const REF = {
    coordX1: null,
    coordY1: null,
    coordX2: null,
    coordY2: null,
    id_task1: null,
    id_task2: null,
    tbody: null,
    fattibileIn: false,
    fattibileOut: false,
};

class Connect {

    constructor() {
        REF.drawLine = this.drawLine;
    }

    setListener() {
        let tbody = document.getElementsByTagName("table")[0];
        tbody.addEventListener('mousedown', this.mousegiu);
        tbody.addEventListener('mouseup', this.mousesu);
        REF.tbody = tbody;
    }

    async mousegiu(e) {
        await new Promise((resolve) => {
            REF.fattibileIn = false;

            let svg = document.getElementById("svg_el");
            if (svg == null || svg == undefined) {
                svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.innerHTML = `<defs>
                    <marker id="arrowhead" markerWidth="5" markerHeight="3" 
                     refX="3" refY="1.5" orient="auto">
                        <polygon points="0 0, 5 1.5, 0 3" />
                    </marker>
                    </defs>`
                svg.setAttribute("id", "svg_el");
                REF.tbody.appendChild(svg);
            }

            let rect = svg.getBoundingClientRect();
            console.log("Offset", rect);
            let cursorX = '';
            let cursorY = '';
            cursorX = e.pageX - rect.x;
            cursorY = e.pageY - rect.y;

            let elements = document.elementsFromPoint(e.pageX, e.pageY);
            console.log("Elementi partenza", elements);
            for (let i = 0; i < elements.length; i++) { // Ciclo tutti i tag individuati nel punto di drop per vedere se c'è l'aside 
                const elemento = (elements[i]);
                if (elemento.tagName.toLowerCase() === 'aside') {
                    REF.id_task1 = elemento.getAttribute('id_task');
                    REF.coordX1 = cursorX;
                    console.log("coordX1 dentro: ", REF.coordX1);
                    REF.coordY1 = cursorY;
                    console.log("Trovato aside");
                    REF.fattibileIn = true;
                }
            } //console.log(REF.id_task1, REF.coordX1);
            resolve();
        });
    }

    async mousesu(e) {

        await new Promise((resolve) => {
            REF.fattibileOut = false;
            let svg = document.getElementById("svg_el");
            let rect = svg.getBoundingClientRect();
            let cursorX = '';
            let cursorY = '';
            cursorX = e.pageX - rect.x;
            cursorY = e.pageY - rect.y;

            let elements = document.elementsFromPoint(e.pageX, e.pageY);
            console.log(elements);
            for (let i = 0; i < elements.length; i++) { // Ciclo tutti i tag individuati nel punto di drop per vedere se c'è l'aside 
                const elemento = (elements[i]);
                if (elemento.tagName.toLowerCase() === 'aside') {
                    REF.id_task2 = elemento.getAttribute('id_task');
                    REF.coordX2 = cursorX;
                    REF.coordY2 = cursorY;
                    REF.fattibileOut = true;
                }
            }

            REF.drawLine();
            REF.tbody.removeEventListener('mousedown', this.mousegiu);
            REF.tbody.removeEventListener('mouseup', this.mousesu);
            REF.id_task1 = null;
            REF.coordX1 = null;
            REF.coordY1 = null;
            REF.id_task2 = null;
            REF.coordX2 = null;
            REF.coordY2 = null;
            resolve();
        });

    }

    async drawLine() {

        console.log("task 1", REF.id_task1, REF.coordX1);
        console.log(REF.id_task2, REF.coordX2);
        console.log("id_task collegati: ", REF.id_task1, REF.id_task2);

        if (REF.fattibileIn && REF.fattibileOut) {
            let svg = document.getElementById("svg_el");

            if (svg == undefined || svg == null) {

                svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.innerHTML = `<defs>
                    <marker id="arrowhead" markerWidth="5" markerHeight="3" 
                     refX="3" refY="1.5" orient="auto">
                        <polygon points="0 0, 5 1.5, 0 3" />
                    </marker>
                    </defs>`
                svg.setAttribute("id", "svg_el");
                REF.tbody.appendChild(svg);
            }

            let div_line = document.createElement("line");
            svg.appendChild(div_line);

            div_line.outerHTML = `
                <line class="linea2" x1="${REF.coordX1}" y1="${REF.coordY1}" x2="${REF.coordX2}" y2="${REF.coordY2}" stroke="black" z-index="15" stroke-width="3" marker-end="url(#arrowhead)" />
                    `;

            /* let line = document.getElementByClass("linea2");
            console.log("line ", line);
    
            line.addEventListener('contextmenu', function () {
                svg.innerHTML = '';
                console.log("Rimosso");
            }); */
            REF.fattibileIn = false;
            REF.fattibileOut = false;

        }
    }

}

export default Connect;